/**
 * The marketing-page type scale, shared by the homepage and the Global Food
 * Report page so the two stay visually consistent.
 */
export const fonts = {
  smallHeader: 'type-24 text-center font-regular',
  h1: 'type-48 lg:type-56 xl:type-64 TTNormsPro font-bold',
  subHeader: 'type-24 lg:type-28 xl:type-32',
  h3: 'type-32 lg:type-48',
  body: 'type-17 lg:type-20',
  ingress: 'type-40 lg:type-56 TTNormsPro mb-24 font-demibold',
  sectionHeading:
    'type-36 lg:type-56 xl:type-64 TTNormsPro text-center font-bold',
}

export default fonts
